import React, { Component } from "react";
import { Jumbotron } from "../components/website-banner/Banner";
// import "./components/Home.css";

class Home extends Component {
  render() {
    return (
      <div class="Home">
        <Jumbotron />
      </div>
    );
  }
}

export default Home;
